<script>
import { useAdmin } from 'dashboard/composables/useAdmin';
import BackButton from '../../../components/widgets/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { isAdmin } = useAdmin();
    return {
      isAdmin,
    };
  },
  computed: {
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
  },
};
</script>

<template>
  <div
    class="sticky top-0 flex min-h-16 items-center justify-between border-b border-auth-border bg-auth-canvas px-4 py-3 dark:border-auth-border-dark dark:bg-auth-canvas-dark sm:px-6"
  >
    <h1
      class="mb-0 flex min-w-0 items-center gap-3 text-auth-text dark:text-auth-text-dark"
    >
      <BackButton
        v-if="showBackButton"
        :button-label="backButtonLabel"
        :back-url="backUrl"
        class="shrink-0"
      />

      <slot />
      <span class="truncate text-lg font-semibold tracking-tight">
        {{ headerTitle }}
      </span>
    </h1>
  </div>
</template>
